import { useGenUiI18n } from '../../../../shared/ui/i18n.js';
import { sumItems } from '@voll-intelligence/intelligence-ui-kit/checkout';
import type { CheckoutCardSlots } from '../../ui/card_slots.js';
import { SummaryFoot } from '../../ui/summary_foot.js';
import { oneClickLive, travelsAlone } from '../checkout_loyalty.js';
import { HotelCheckoutLoyalty } from './checkout_loyalty.js';
import { HotelCheckoutStay, hotelNightsNote, type HotelCheckoutItem } from './checkout_stay.js';

/** O card do hotel: a «Hospedagem» de cada estadia (o agente emite uma), a
 *  conferência do 1-Click, a fidelidade de quem
 *  viaja sozinho e o rodapé com o total do grupo de quartos — «pelas
 *  N noites» quando a estadia é uma só. */
export function HotelCheckoutCard({
  items,
  slots,
}: {
  readonly items: readonly HotelCheckoutItem[];
  readonly slots: CheckoutCardSlots;
}) {
  const { t } = useGenUiI18n();
  const [only, ...rest] = items;
  const caption = only && rest.length === 0 ? hotelNightsNote(only, t) : undefined;
  return (
    <>
      <div className="checkout__body">
        {items.map((item) => (
          <HotelCheckoutStay key={item.offerId} item={item} />
        ))}
      </div>
      {slots.review}
      <HotelCheckoutLoyalty
        items={items}
        self={travelsAlone(slots.checkout)}
        record={!oneClickLive(slots.flow)}
      />
      <SummaryFoot
        valueKey="common.total"
        value={sumItems(items)}
        {...(caption ? { caption } : {})}
        inPolicy={slots.flow.withinPolicy}
        shieldAriaKey="productCheckout.hotel.outOfPolicy"
        shieldTitleKey="productCheckout.hotel.outOfPolicy"
        actions={slots.actions('productCheckout.reserveHotel')}
      />
    </>
  );
}
